import { useAccount, useReadContract } from 'wagmi';
import { TARGET_CHAIN } from './config';
import { getChainlinkFeed, AGGREGATOR_V3_ABI } from './priceFeeds';

// Real-world USD price for a symbol, independent of our own AMM pool reserves.
export function useChainlinkPrice(symbol: string) {
  const { chainId } = useAccount();
  const readChainId = chainId ?? TARGET_CHAIN.id;
  const feedAddress = getChainlinkFeed(symbol, readChainId);

  const { data } = useReadContract({
    address: feedAddress,
    abi: AGGREGATOR_V3_ABI,
    functionName: 'latestRoundData',
    chainId: readChainId,
    query: { enabled: Boolean(feedAddress), refetchInterval: 15000 },
  });

  const { data: decimals } = useReadContract({
    address: feedAddress,
    abi: AGGREGATOR_V3_ABI,
    functionName: 'decimals',
    chainId: readChainId,
    query: { enabled: Boolean(feedAddress) },
  });

  if (!data || decimals === undefined) return undefined;
  const [, answer] = data;
  return Number(answer) / 10 ** decimals;
}
